import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../ampli';
import EventImage01 from '../../../assets/images/event202402/240216_event_01.jpg';
import EventImage02 from '../../../assets/images/event202402/240216_event_02.jpg';
import EventImage03 from '../../../assets/images/event202402/240216_event_03.jpg';
import EventImage04 from '../../../assets/images/event202402/240216_event_04.jpg';
import EventImage05 from '../../../assets/images/event202402/240216_event_05.jpg';
import EventImage06 from '../../../assets/images/event202402/240216_event_06.jpg';
import EventImage07 from '../../../assets/images/event202402/240216_event_07.jpg';
import EventImage08 from '../../../assets/images/event202402/240216_event_08.jpg';
import EventImage09 from '../../../assets/images/event202402/240216_event_09.jpg';
import EventImage10 from '../../../assets/images/event202402/240216_event_10.jpg';
import EventImage11 from '../../../assets/images/event202402/240216_event_11.jpg';
import EventImage12 from '../../../assets/images/event202402/240216_event_12.jpg';
import EventImage13 from '../../../assets/images/event202402/240216_event_13.jpg';
import EventImage14 from '../../../assets/images/event202402/240216_event_14.jpg';
import EventImage15 from '../../../assets/images/event202402/240216_event_15.jpg';
import EventImage16 from '../../../assets/images/event202402/240216_event_16.jpg';
import EventImage17 from '../../../assets/images/event202402/240216_event_17.jpg';
import EventImage18 from '../../../assets/images/event202402/240216_event_18.jpg';
import EventImage19 from '../../../assets/images/event202402/240216_event_19.jpg';
import EventImage20 from '../../../assets/images/event202402/240216_event_20.jpg';
import EventImage21 from '../../../assets/images/event202402/240216_event_21.jpg';
import EventImage22 from '../../../assets/images/event202402/240216_event_22.jpg';
import EventImage23 from '../../../assets/images/event202402/240216_event_23.jpg';
import EventImage24 from '../../../assets/images/event202402/240216_event_24.jpg';
import EventImage25 from '../../../assets/images/event202402/240216_event_25.jpg';
import EventImage26 from '../../../assets/images/event202402/240216_event_26.jpg';
import EventImage27 from '../../../assets/images/event202402/240216_event_27.jpg';
import EventImage28 from '../../../assets/images/event202402/240216_event_28.jpg';
import { MainHead } from '../../../components/common/head/MainHead';
import { PopupConfirmModal } from '../../../components/common/modal/popup/PopupConfirmModal';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { usePutUsersMeMutation } from '../../../hooks/api/user/mutations/usePutUsersMe.mutation';
import { usePopup } from '../../../hooks/popup/usePopup';
import { useLayout } from '../../../hooks/screen/useLayout';
import { useCheckUserLoggedIn } from '../../../hooks/user/useCheckUserLoggedIn';
import { useGetUserProfile } from '../../../hooks/user/useGetUserProfile';
import { postMessageToRN } from '../../../utils/RNCommunicator/postMessageToRN.util';

export const EventPage202402 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const Popup = usePopup();

  const [isLoginModalShow, setIsLoginModalShow] = useState<boolean>(false);
  const [isMarketingModalShow, setIsMarketingModalShow] = useState<boolean>(false);
  const [isBenefitModalShow, setIsBenefitModalShow] = useState<boolean>(false);

  const { isUserLoggedIn } = useCheckUserLoggedIn();
  const { userProfile } = useGetUserProfile();
  const { mutate: putUsersMe } = usePutUsersMeMutation();

  const handleShareButtonClick = () => {
    ampli.이벤트값진년공유하기버튼클릭({ '유저 ID': userProfile?.id ?? '' });

    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'share', messageParam: window.location.href });
    } else {
      window.navigator.clipboard.writeText(window.location.href);
      Popup.toast('현재 게시물의 주소가 복사되었습니다.\n복사된 주소를 문자 등으로 지인에게 추천하세요!');
    }
  };

  const handleDoReceiveBenefitButtonClick = () => {
    ampli.이벤트값진년혜택받기버튼클릭({ '유저 ID': userProfile?.id ?? '' });

    if (isUserLoggedIn) {
      if (userProfile?.marketingTermsAgreement === false) {
        setIsMarketingModalShow(true);
      } else {
        setIsBenefitModalShow(true);
      }
    } else {
      setIsLoginModalShow(true);
    }
  };

  const turnOnMarketingTermsAgreement = () => {
    putUsersMe(
      { reqBody: { marketingTermsAgreement: true } },
      {
        onSuccess: () => {
          setIsBenefitModalShow(true);
          setIsMarketingModalShow(false);
        },
      },
    );
  };

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true, directlyPassedURL: pageInfo.infoListPage.path }} />,
    fixedFooter: <></>,
    fixedHeaderHeight: 40,
    style: {
      background: '#F0f0f0',
    },
  });

  return (
    <>
      <Helmet>
        <title>{'값찐 이벤트! - Pluva Market'}</title>
      </Helmet>

      <Container>
        <Image1 src={EventImage01} />

        <DoReceiveBenefit src={EventImage02} onClick={handleDoReceiveBenefitButtonClick} />

        <Image2 src={EventImage03} />

        <DoSharePage src={EventImage04} onClick={handleShareButtonClick} />

        <Image3 src={EventImage05} />

        <GoTo004
          src={EventImage06}
          onClick={() => {
            navigate('/market/pluva/603b5d79-c838-4490-8236-5cd52ae48bdf');
            ampli.이벤트값진년보러가기버튼클릭({ '매물 코드': '004' });
          }}
        />

        <Product005 src={EventImage07} />
        <GoTo005
          src={EventImage08}
          onClick={() => {
            navigate('/market/pluva/f11a8068-aa57-4e09-9129-82703317988b');
            ampli.이벤트값진년보러가기버튼클릭({ '매물 코드': '005' });
          }}
        />

        <Product006 src={EventImage09} />
        <GoTo006
          src={EventImage10}
          onClick={() => {
            navigate('/market/pluva/d680ae24-b21b-4cf1-b27e-3265a07f6160');
            ampli.이벤트값진년보러가기버튼클릭({ '매물 코드': '006' });
          }}
        />

        <Product007 src={EventImage11} />
        <GoTo007
          src={EventImage12}
          onClick={() => {
            navigate('/market/pluva/84c13343-9979-4e62-a766-4605c006be1c');
            ampli.이벤트값진년보러가기버튼클릭({ '매물 코드': '007' });
          }}
        />

        <Product008 src={EventImage13} />
        <GoTo008
          src={EventImage14}
          onClick={() => {
            navigate('/market/pluva/d22636ff-ceed-468d-ab11-340ac3686e2a');
            ampli.이벤트값진년보러가기버튼클릭({ '매물 코드': '008' });
          }}
        />

        <Image4 src={EventImage15} />

        <GoToSellTractor
          src={EventImage16}
          onClick={() => {
            navigate('/survey/entry/sell-tractor');
            ampli.이벤트값진년내트랙터팔기버튼클릭();
          }}
        />
        <GoToOpenMarket
          src={EventImage17}
          onClick={() => {
            navigate('/open-market/list');
            ampli.이벤트값진년직거래바로가기버튼클릭();
          }}
        />

        <Image5 src={EventImage18} />

        <GoToMore1
          src={EventImage19}
          onClick={() => {
            navigate('/market/pluva/ef479c0a-e99c-4c58-9261-51bd0e7ba69e');
            ampli.이벤트값진년보러가기버튼클릭({ '매물 코드': '015' });
          }}
        />

        <ProductMore2 src={EventImage20} />
        <GoToMore2
          src={EventImage21}
          onClick={() => {
            navigate('/market/pluva/22bde45f-7139-4880-b751-791f62504108');
            ampli.이벤트값진년보러가기버튼클릭({ '매물 코드': '014' });
          }}
        />

        <ProductMore3 src={EventImage22} />
        <GoToMore3
          src={EventImage23}
          onClick={() => {
            navigate('/market/pluva/cfe2bde9-cec9-4f66-89fe-ad218d64b8ed');
            ampli.이벤트값진년보러가기버튼클릭({ '매물 코드': '009' });
          }}
        />

        <Image5 src={EventImage24} />

        <GoToMarket
          src={EventImage25}
          onClick={() => {
            navigate('/products/list');
            ampli.이벤트값진년마켓살펴보기버튼클릭();
          }}
        />

        <Image6 src={EventImage26} />

        <GoToNH
          src={EventImage27}
          onClick={() => {
            navigate('/info/6f7f1fc8-85ce-40b0-8447-6b0ac2a9c43d');
            ampli.이벤트값진년농협중고농기계구입자금안내버튼클릭();
          }}
        />

        <Image7 src={EventImage28} />
      </Container>

      <PopupConfirmModal
        isShow={isLoginModalShow}
        hasCloseButton={false}
        closeModal={() => setIsLoginModalShow(false)}
        title={'로그인하고 혜택 받기 🎉'}
        description={'로그인 하시고\n할인 혜택을 누리세요!'}
        buttonArray={[
          {
            text: '로그인',
            onClick: () => navigate('/oauth/login'),
            color: 'blue',
          },
          {
            text: '닫기',
            onClick: () => setIsLoginModalShow(false),
            color: 'gray',
          },
        ]}
      />

      <PopupConfirmModal
        isShow={isMarketingModalShow}
        hasCloseButton={false}
        closeModal={() => setIsMarketingModalShow(false)}
        title={'마케팅 수신동의 약관 동의 ☝🏻'}
        description={'이벤트, 할인, 새매물 등\n새롭고 유용한 소식이 있을때\n직접 알림을 드려요!'}
        buttonArray={[
          {
            text: '동의하기',
            onClick: () => {
              turnOnMarketingTermsAgreement();
              ampli.이벤트값진년마케팅수신동의버튼클릭({ '유저 ID': userProfile?.id ?? '' });
            },
            color: 'blue',
          },
          {
            text: '괜찮아요',
            onClick: () => setIsMarketingModalShow(false),
            color: 'gray',
          },
        ]}
      />

      <PopupConfirmModal
        isShow={isBenefitModalShow}
        hasCloseButton={false}
        closeModal={() => setIsBenefitModalShow(false)}
        title={'혜택 적용 완료 🎉'}
        buttonArray={[
          {
            text: '확인',
            onClick: () => setIsBenefitModalShow(false),
            color: 'blue',
          },
        ]}
      />
    </>
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 100%;
`;

const Image1 = styled(Image)``;
const Image2 = styled(Image)``;
const Image3 = styled(Image)``;
const Image4 = styled(Image)``;
const Image5 = styled(Image)``;
const Image6 = styled(Image)``;
const Image7 = styled(Image)``;
const Image8 = styled(Image)``;
const Image9 = styled(Image)``;
const Image10 = styled(Image)``;

const AlreadyReceivedBenefit = styled(Image)``;

const Product004 = styled(Image)``;
const Product005 = styled(Image)``;
const Product006 = styled(Image)``;
const Product007 = styled(Image)``;
const Product008 = styled(Image)``;

const ProductMore1 = styled(Image)``;
const ProductMore2 = styled(Image)``;
const ProductMore3 = styled(Image)``;

const ButtonImage = styled(Image)`
  cursor: pointer;
`;

const DoReceiveBenefit = styled(ButtonImage)``;
const DoSharePage = styled(ButtonImage)``;

const GoTo004 = styled(ButtonImage)``;
const GoTo005 = styled(ButtonImage)``;
const GoTo006 = styled(ButtonImage)``;
const GoTo007 = styled(ButtonImage)``;
const GoTo008 = styled(ButtonImage)``;

const GoToMore1 = styled(ButtonImage)``;
const GoToMore2 = styled(ButtonImage)``;
const GoToMore3 = styled(ButtonImage)``;

const GoToSellTractor = styled(ButtonImage)``;
const GoToOpenMarket = styled(ButtonImage)``;
const GoToMarket = styled(ButtonImage)``;
const GoToNH = styled(ButtonImage)``;
